
/*
 * @license @wistia/type-guards v0.9.1
 *
 * Copyright (c) 2023-2025, Wistia, Inc. and its affiliates.
 *
 * This source code is unlicensed, all rights reserved.
 */


// index.ts
var FALSY_VALUES = [false, 0, -0, 0n, "", null, void 0, Number.NaN];
var isNull = (value) => value === null;
var isNotNull = (value) => !isNull(value);
var isUndefined = (value) => value === void 0;
var isNotUndefined = (value) => !isUndefined(value);
var isNil = (value) => isNull(value) || isUndefined(value);
var isNotNil = (value) => !isNil(value);
var isString = (value) => typeof value === "string";
var isNotString = (value) => !isString(value);
var isEmptyString = (value) => isString(value) && value === "";
var isNonEmptyString = (value) => isString(value) && !isEmptyString(value);
var isNumber = (value) => typeof value === "number";
var isNotNumber = (value) => !isNumber(value);
var isNaN = (value) => Number.isNaN(value);
var isInteger = (value) => Number.isInteger(value);
var isRecord = (value) => isNotNil(value) && typeof value === "object" && !(value instanceof Array);
var isNotRecord = (value) => !isRecord(value);
var isEmptyRecord = (value) => isRecord(value) && Object.keys(value).length === 0;
var isNonEmptyRecord = (value) => isRecord(value) && Object.keys(value).length > 0;
var isArray = (value) => isNotNil(value) && typeof value === "object" && value instanceof Array;
var isNotArray = (value) => !isArray(value);
var isEmptyArray = (value) => isArray(value) && value.length === 0;
var isNonEmptyArray = (value) => isArray(value) && value.length > 0;
var isFunction = (value) => isNotNil(value) && typeof value === "function";
var isNotFunction = (value) => !isFunction(value);
var isBoolean = (value) => isNotNil(value) && typeof value === "boolean";
var isNotBoolean = (value) => !isBoolean(value);
var isVoid = (value) => value === void 0;
var isNotVoid = (value) => !isVoid(value);
var isError = (value) => {
  return isNotNil(value) && value instanceof Error;
};
var isFalsy = (value) => FALSY_VALUES.includes(value) || Number.isNaN(value);
var isTruthy = (value) => !FALSY_VALUES.includes(value) && !Number.isNaN(value);
var hasKey = (value, key) => isNonEmptyRecord(value) && key in value;
export {
  hasKey,
  isArray,
  isBoolean,
  isEmptyArray,
  isEmptyRecord,
  isEmptyString,
  isError,
  isFalsy,
  isFunction,
  isInteger,
  isNaN,
  isNil,
  isNonEmptyArray,
  isNonEmptyRecord,
  isNonEmptyString,
  isNotArray,
  isNotBoolean,
  isNotFunction,
  isNotNil,
  isNotNull,
  isNotNumber,
  isNotRecord,
  isNotString,
  isNotUndefined,
  isNotVoid,
  isNull,
  isNumber,
  isRecord,
  isString,
  isTruthy,
  isUndefined,
  isVoid
};
//# sourceMappingURL=index.mjs.map